import React from 'react';
import { Link } from 'react-router-dom';
import { themes } from '../components/ThemeSelector';
import pokeballSprite from '../assets/pokeballs/poke-ball.png';
import greatballSprite from '../assets/pokeballs/great-ball.png';
import ultraballSprite from '../assets/pokeballs/ultra-ball.png';
import './Home.css';

function Home({ currentTheme = 'pokeball' }) {
  const themeSprite = themes[currentTheme]?.sprite || pokeballSprite;
  
  return (
    <div className="home">
      <section className="hero" style={{ '--theme-pokeball': `url(${themeSprite})` }}>
        <div className="hero-content">
          <h1>Welcome to PokéComp</h1>
          <p className="hero-subtitle">
            Master the art of competitive Pokémon battling with our comprehensive learning platform
          </p>
          <Link to="/database" className="cta-button">
            Start Learning
          </Link>
        </div>
      </section>

      <section className="features">
        <h2>What We Offer</h2>
        <div className="feature-grid">
          <div className="feature-card">
            <img src={pokeballSprite} alt="Pokédex Database" className="feature-icon" />
            <h3>Complete Pokédex</h3>
            <p>Access detailed information about every Pokémon, including stats, abilities, and competitive usage.</p>
            <Link to="/database" className="feature-link">Explore Pokédex →</Link>
          </div>

          <div className="feature-card">
            <img src={greatballSprite} alt="Type Matchups" className="feature-icon" />
            <h3>Type Matchups</h3>
            <p>Master type effectiveness with our interactive chart and quiz system. Test your knowledge!</p>
            <Link to="/types" className="feature-link">Learn Types →</Link>
          </div>

          <div className="feature-card">
            <img src={ultraballSprite} alt="Competitive Builds" className="feature-icon" />
            <h3>Competitive Builds</h3>
            <p>Discover popular competitive builds, strategies, and team compositions used by top players.</p>
            <Link to="/competitive" className="feature-link">View Builds →</Link>
          </div>
        </div>
      </section>

      <section className="quick-links">
        <h2>Quick Access</h2>
        <div className="quick-links-grid">
          <Link to="/moves" className="quick-link">
            <h4>Moves Database</h4>
            <p>Browse and learn about all Pokémon moves</p>
          </Link>
          <Link to="/abilities" className="quick-link">
            <h4>Abilities Guide</h4>
            <p>Understand Pokémon abilities and their effects</p>
          </Link>
          <Link to="/items" className="quick-link">
            <h4>Items Catalog</h4>
            <p>Explore competitive items and their uses</p>
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Home; 